/* eslint-disable */
import { api } from '@/services';

export default {
    async fetchAll({ commit }) {
        const { data: despesas } = await api.get('/processo/despesas-detalhado');
        commit('SET_DESPESAS', despesas);
    },
    limpar({ commit }) {
        commit('SET_DESPESAS', []);
    },
    filtrar() {

    },
}